import React from 'react';

const ServiceHero = ({ data }) => {
  return (
    <section className="relative min-h-[50vh] flex items-center overflow-hidden pt-32 pb-20" style={{ background: '#F8FAFC' }}>
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px]" style={{ background: 'radial-gradient(circle, rgba(38,147,255,0.06) 0%, transparent 70%)' }} />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl">
          <p className="text-sm font-semibold uppercase tracking-widest mb-4 font-heading" style={{ color: '#2693FF' }}>
            Services
          </p>
          <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-slate-900 font-heading mb-6 leading-tight">
            {data.title}
          </h1>
          <h2 className="text-xl sm:text-2xl md:text-3xl font-medium text-slate-700 font-heading mb-6">
            {data.subtitle}
          </h2>
          <p className="text-lg text-slate-500 leading-relaxed max-w-3xl">
            {data.description}
          </p>
        </div>
      </div>
    </section>
  );
};

export default ServiceHero;
